module.exports = __webpack_public_path__ + "assets/media/announcer_ment_training_5.c8928c32.mp3";